export const GET_REVIEWS = 'reviews/GET_REVIEWS';
export const GET_REVIEWS_BY_STUDENT_ID = 'reviews/GET_REVIEWS_BY_STUDENT_ID';
